module.exports = __webpack_public_path__ + "img/footer04.ff1f43a5.png";